import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withMemo as _withMemo, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "company-data mr-2" }
const _hoisted_2 = { class: "uppercase text-raleway-13" }
const _hoisted_3 = { class: "uppercase text-raleway-13" }
const _hoisted_4 = { class: "uppercase text-raleway-13" }
const _hoisted_5 = { class: "data-location" }
const _hoisted_6 = { class: "data-personal" }
const _hoisted_7 = { class: "double-select mr-2" }
const _hoisted_8 = { class: "uppercase text-raleway-13" }
const _hoisted_9 = { class: "mt-2 mb-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import { PersonalDataComponentValidation } from "@/utils/validation/accauntDetailsValidation/personalDataComponent";
import { PersonalDataComponent } from "@/store/modules/accountDetails/type";
import { computed, inject, onBeforeMount, ref, watch } from "vue";
import { IStore } from "@/store/types/StoreType";
import { Field, useForm } from "vee-validate";
import { useStore } from "vuex";

import PhoneComponent from "@/components/phone/phoneComponent.vue";
import LocationComponent from "./location/locationComponent.vue";
import VatNumberComponent from "./vat/vatNumberComponent.vue";
import CityComponent from "./city/cityComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'personalDataComponent',
  setup(__props) {

const store = useStore<IStore>();

const initialValues = ref<PersonalDataComponent>(
  store.getters?.getPersonalDataComponenValuesAccountDetails
);

const { meta, errors, values, resetForm, validate } =
  useForm<PersonalDataComponent>({
    initialValues: { ...initialValues.value },
    validationSchema: PersonalDataComponentValidation,
  });

const addForm = inject<any>("ADD_FORM");

addForm({
  position: 1,
  initialValues,
  meta,
  errors,
  values,
  validate,
  resetForm,
});

const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
const errorValues = ref();
const allErrors = ref();

watch(
  () => store.getters?.getGlobalErrorsPersonalDataComponent || [],
  (value) => {
    allErrors.value = value;
    errorValues.value = allErrors.value.map((value: any) =>
      Array.isArray(Object.keys(value))
        ? Object.keys(value)[0]
        : Object.keys(value)
    );
  },
  {
    deep: true,
  }
);

watch(
  () => values,
  () => {
    store.commit("updatePersonalDataComponentValues", values);
  },
  {
    deep: true,
  }
);

watch(
  () => uiLang.value,
  () => {
    if (values.postal_code) return;
    store.commit("updatePersonalDataComponenValuesAccountDetails");
  }
);

onBeforeMount(() => {
  store.dispatch("getCountryPostalcode");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "company-details",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(validate)()), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withMemo([
          uiLang.value,
          _unref(errors)?.firm_name,
          _unref(values)?.firm_name,
          initialValues.value?.firm_name,
        ], () => (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["mr-2", { 'error-input error-input_long': !!_unref(errors)?.firm_name }])
      }, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$tc("Client’s Name")), 1),
        _createVNode(_unref(Field), {
          tabindex: "1",
          maxlength: "30",
          type: "text",
          name: "firm_name",
          class: "input input-mini",
          value: _unref(values)?.firm_name,
          placeholder: _ctx.$tc('Client’s Name')
        }, null, 8, ["value", "placeholder"])
      ], 2)), _cache, 0),
      _createElementVNode("div", {
        class: _normalizeClass(["mr-2", { 'error-input error-input_long': !!_unref(errors)?.buyer_phone }])
      }, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$tc("Company phone number")), 1),
        _createVNode(PhoneComponent, {
          tabindex: 3,
          class: _normalizeClass({ 'error-input_phone': !!_unref(errors)?.buyer_phone }),
          value: _unref(values)?.buyer_phone || '',
          placeholder: '###-###-##',
          name: 'buyer_phone',
          start: _unref(values).buyer_phone_start,
          change: 'changeStartValue_buyer_phone_start'
        }, null, 8, ["class", "value", "start"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ 'error-input error-input_long': !!_unref(errors)?.buyer_email })
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$tc("company email address")), 1),
        _createVNode(_unref(Field), {
          tabindex: 4,
          maxlength: "55",
          type: "text",
          name: "buyer_email",
          class: "input input-mini",
          value: _unref(values)?.buyer_email,
          placeholder: _ctx.$tc('contact person Email address')
        }, null, 8, ["value", "placeholder"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(LocationComponent, {
        region: _unref(errors).region || '',
        postal_code: _unref(errors).postal_code || '',
        country: _unref(errors).country || ''
      }, null, 8, ["region", "postal_code", "country"]),
      _createVNode(VatNumberComponent, {
        errors: _unref(errors)?.buyer_vat || '',
        buyer_vat_start: _unref(values).buyer_vat_start,
        buyer_vat: _unref(values).buyer_vat || '',
        initialValues: initialValues.value.buyer_vat || ''
      }, null, 8, ["errors", "buyer_vat_start", "buyer_vat", "initialValues"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _withMemo([], () => _createVNode(CityComponent, {
          error: _unref(errors).city
        }, null, 8, ["error"]), _cache, 1),
        _withMemo([uiLang.value, _unref(errors)?.full_address, initialValues.value?.full_address], () => (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["input-wrapper input-slim", { 'error-input mini': !!_unref(errors)?.full_address }])
        }, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$tc("address")), 1),
          _createVNode(_unref(Field), {
            tabindex: 5,
            maxlength: "30",
            type: "text",
            name: "full_address",
            class: "input input-mini",
            value: initialValues.value?.full_address || '',
            placeholder: _ctx.$tc('Address'),
            onFocusout: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).commit('updateChedulesLocationAddress')))
          }, null, 8, ["value", "placeholder"])
        ], 2)), _cache, 3)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allErrors.value, (error) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "uppercase text-raleway-13 t-danger text-center",
          key: error
        }, [
          (typeof error === 'object')
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(Object.keys(error) + ": " + Object.values(error)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(error), 1))
        ]))
      }), 128))
    ], 512), [
      [_vShow, allErrors.value]
    ])
  ], 32))
}
}

})